import api from './api';

const state = {
	tenant: null,
	tenants: null,
	loading: false,
};

const getters = {};

const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
	},
	setTenant(state, { tenant }) {
		state.tenant = tenant;
		localStorage.setItem('tenant', JSON.stringify(tenant));
	},
	setTenants(state, { tenants }) {
		state.tenants = tenants;
	},
};

const actions = {
	async load({ state, commit, rootGetters }) {
		commit('startLoading');
		api.list()
			.then(response => {
				let tenants = response.data;
				let tenant;
				if (localStorage.getItem('tenant')) {
					let localTenant = JSON.parse(localStorage.getItem('tenant'));
					tenant = tenants.find(o => o.id == localTenant.id && o.deleted == false);
				}

				if (!tenant) {
					tenant = tenants.find(o => o.deleted == false);
				}

				commit('setTenant', { tenant });
				commit('setTenants', { tenants });

				commit('stopLoading');
			})
			.catch(err => {
				console.log(err);
				commit('stopLoading');
			});
	},

	getTenants({ state, commit, rootGetters }) {
		commit('startLoading');
		api.list()
			.then(response => {
				const tenants = response.data;
				commit('setTenants', { tenants });

				commit('stopLoading');
			})
			.catch(err => {
				console.log(err);
				commit('stopLoading');
			});
	},

	async changeTenant({ commit }, { newTenant }) {
		if (newTenant) {
			await commit('setTenant', { tenant: newTenant });
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
